import { render, staticRenderFns } from "./ManageData.vue?vue&type=template&id=770f5d14&"
import script from "./ManageData.vue?vue&type=script&lang=js&"
export * from "./ManageData.vue?vue&type=script&lang=js&"
import style0 from "./ManageData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports